import { withRouter } from "react-router-dom";
import moment from "moment";
import { useEffect, useState } from "react";
import axios from "axios";
import { Text } from "@doordash/design-language";
import { BBOT_DJANGO_SERVER } from "Config";
import { BbotTable, OPContainer, PageLoadingSpinner } from "top-component-library";
import { generalErrorAlert } from "util/Utils";

import { LegacyLinkAlert } from "./styles";

const { Medium12 } = Text;

const DATE_FORMAT = "ddd, MMM D, YYYY h:mm A";

const PAGINATION_CONFIG = {
  defaultPageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "15", "25"],
};

const COLUMNS = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Unique ID", dataIndex: "unique_id", key: "unique_id" },
  { title: "Config Name", dataIndex: "config_name", key: "config_name" },
  { title: "Environment", dataIndex: "release_channel", key: "release_channel" },
  { title: "Version", dataIndex: "apk_version", key: "apk_version" },
  { title: "Platform", dataIndex: "platform", key: "platform" },
  { title: "Registered", dataIndex: "registered_on", key: "registered_on" },
  { title: "Device Manager", dataIndex: "mdm", key: "mdm" },
  { title: "Last Connected", dataIndex: "last_poll_time", key: "last_poll_time" },
];

const toDisplayRows = (devices) =>
  devices.map((device) => ({
    ...device,
    last_poll_time: moment(device.last_poll_time).format(DATE_FORMAT),
    registered_on: moment(device.registered_on).format(DATE_FORMAT),
  }));

const HandheldDevices = (props) => {
  const legacyLink =
    BBOT_DJANGO_SERVER +
    (props.userInfo?.role === "admin" ? "/superuser/console/#!/edit/devices" : "/owner/console/#!/edit/devices");
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const getHandheldDevices = async () => {
      try {
        const res = await axios.get("/api/ownerdevices");
        setDevices(toDisplayRows(res.data?.devices ?? []));
      } catch (error) {
        setHasError(true);
        generalErrorAlert(error, "Trouble getting handheld devices. Please refresh and try again.");
      } finally {
        setIsLoading(false);
      }
    };
    getHandheldDevices();
  }, []);

  const renderBody = () => {
    if (isLoading) {
      return <PageLoadingSpinner />;
    }
    if (hasError) {
      return <Text styles={Medium12}>Unable to load devices. Please refresh and try again.</Text>;
    }
    if (devices.length === 0) {
      return <Text styles={Medium12}>No devices found.</Text>;
    }
    return <BbotTable manuallyFormattedColumns={COLUMNS} data={devices} rowKey="id" pagination={PAGINATION_CONFIG} />;
  };

  return (
    <OPContainer
      title="Handheld Devices"
      url="/devices"
      selectedCustomer={props.selectedCustomer}
      userInfo={props.userInfo}
    >
      <LegacyLinkAlert
        message={
          <span>
            We&apos;ve updated the Handheld Devices page. To access the old page, follow this{" "}
            <a href={legacyLink}>link</a>.
          </span>
        }
      />
      {renderBody()}
    </OPContainer>
  );
};

export default withRouter(HandheldDevices);
